import Loadable from 'react-loadable';
import { ModuleLoadingPage } from '@agora/agora-common/Loading';

const Admin = Loadable({
  loader: () => import('./AdminContainer'),
  timeout: 60000,
  loading: ModuleLoadingPage,

});

export default Admin;
